import { EventUI } from './../models/event.model';

export type EventState = EventUI[];

export const initialState: EventState = [] as EventState;
